import React from 'react';
import { Alert } from '@smarterservices/smarter-ui';
import { BlockComponentProps, AlertBlock as AlertBlockType } from '../../types';
import { formatText } from '../../utils/textFormatter';

/**
 * AlertBlock component renders an alert message with different severity levels
 * 
 * @param {BlockComponentProps<AlertBlockType>} props - Component props
 * @returns {React.ReactElement} Rendered alert
 */
export const AlertBlock = ({ block }: BlockComponentProps<AlertBlockType>) => {
  // Default to info if severity is not provided
  const severity = block.severity || 'info';
  
  // Generate screen reader label based on severity
  const getScreenReaderLabel = () => {
    switch (severity) {
      case 'success':
        return 'Success';
      case 'warning':
        return 'Warning';
      case 'error':
        return 'Error';
      case 'info':
      default:
        return 'Information';
    }
  };

  return (
    <Alert
      variant={severity}
      transition="none"
      margin={block.margin || "small 0"}
      variantScreenReaderLabel={getScreenReaderLabel()}
    >
      {formatText(block.text, block.replacements)}
    </Alert>
  );
};

export default AlertBlock;
